// extracted by mini-css-extract-plugin
export default {"container":"confirmModal_container__BOP7k","btns":"confirmModal_btns__HGmY3"};